<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16">订单作废</div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <div class="member-header">
            <div class="flex-row space-between">
              <div class="flex-row">
                <!-- @change="selectChange" -->
                <el-select v-model="query.auditStatus" class="mr10" placeholder="审核状态" filterable>
                  <el-option label="全部状态" value></el-option>
                  <el-option label="待审核" value="wait"></el-option>
                  <el-option label="审核通过" value="pass"></el-option>
                  <el-option label="审核不通过" value="refuse"></el-option>
                </el-select>
              </div>
            </div>
            <v-date @time="changeDate" class="mr10"></v-date>
            <el-button type="primary" class="small-btn" @click="doData">搜索</el-button>
          </div>
          <div class="plr16" v-perm="{key:'orderInvaild', value:'orderInvaild:list'}">
            <el-table :data="list" :max-height="height - 266" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="orderTitle" label="订单名称"></el-table-column>
              <el-table-column prop="auditStatusCn" label="审核状态" width="120px"></el-table-column>
              <el-table-column prop="orderRealPayAmount" width="120px" label="订单金额"></el-table-column>
              <el-table-column prop="applyStaffIdCn" label="申请技师" width="auto"></el-table-column>
              <el-table-column prop="oxCtime" label="申请时间" width="auto">
                <template slot-scope="scope">{{ formatDate(scope.row.oxCtime) }}</template>
              </el-table-column>
              <el-table-column prop="oxLtime" label="通过时间/拒绝时间" width="170px">
                <template slot-scope="scope" v-if="scope.row.auditStatus != 'wait'">{{ formatDate(scope.row.oxLtime) }}</template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                  <div v-if="!scope.row.tatalsShow">
                    <el-link type="primary" @click="orderDetailPage(scope.row)">详情</el-link>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <edit-set ref="editSetForm" @change="handleChange"></edit-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import editSet from "./edit";
export default {
  data() {
    return {
      url: this.$url.orderInvalid.list,
      query: {
        beginTime: new Date(),
        endTime: new Date(),
        auditStatus: "",
        start: 0,
        size: 20
      },
      height: this.$store.getters.MainHeight,
      list: []
    };
  },
  mixins: [minxin],
  components: { editSet },
  computed: {},

  created() {
    this.totalCounts();
  },

  methods: {
    back() {
      this.$router.push("/collectMoney");
    },
    changeDate(value) {
      this.query.start = 0;
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
      // this.getList();
    },
    orderDetailPage(row) {
      // this.$router.push(`/repair/detail/${row.id}`);
      this.$refs["editSetForm"].$emit("set", row);
    },
    handleChange(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
    totalCounts () {
      this.$api.post(this.$url.orderInvalid.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
    selectChange() {
      this.totalCounts();
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  height: calc(100% - 72px);
  .member-content-box {
    background: #fff;
  }
  .member-header {
    padding: 16px;
    display: flex;
    align-items: center;
  }
}
</style>

